import { readSection, writeSection } from '../cache'

const { VUE_APP_API_HOST } = process.env

const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })

/**
 * Appels /dashboards (tableaux de bord personnalisés) ; la liste est gardée en cache local par utilisateur
 */
export default {
  methods: {
    dashboardsCacheUser() {
      try {
        const user = localStorage.user && localStorage.user != 'undefined' ? JSON.parse(localStorage.user) : null
        return user && user.id
      } catch (e) {
        return null
      }
    },

    cachedDashboards() {
      return readSection(this.dashboardsCacheUser(), 'dashboards') || null
    },

    async fetchDashboards() {
      const res = await this.$http.get(`${VUE_APP_API_HOST}/dashboards`, auth())
      const list = (res.body && res.body.dashboards) || []
      writeSection(this.dashboardsCacheUser(), 'dashboards', list)
      return list
    },

    async fetchDashboard(id) {
      const res = await this.$http.get(`${VUE_APP_API_HOST}/dashboards/${id}`, auth())
      return res.body.dashboard
    },

    async createDashboard(data) {
      const res = await this.$http.post(`${VUE_APP_API_HOST}/dashboards`, data, auth())
      return res.body.dashboard
    },

    async updateDashboard(id, data) {
      const res = await this.$http.put(`${VUE_APP_API_HOST}/dashboards/${id}`, data, auth())
      return res.body.dashboard
    },

    async removeDashboard(id) {
      await this.$http.delete(`${VUE_APP_API_HOST}/dashboards/${id}`, auth())
    },

    async duplicateDashboard(id, name) {
      const res = await this.$http.post(`${VUE_APP_API_HOST}/dashboards/${id}/duplicate`, { name }, auth())
      return res.body.dashboard
    },

    // « Tableau de bord N » : premier numéro libre parmi les noms existants
    defaultDashboardName(list) {
      const base = this.$t('dash.overview.dashboards.default_name')
      const used = new Set((list || []).map(d => d.name))
      let n = 1
      while (used.has(`${base} ${n}`)) n++
      return `${base} ${n}`
    }
  }
}
